import { render, staticRenderFns } from "./SectionMenuNotifications.vue?vue&type=template&id=6f757e79&scoped=true&"
import script from "./SectionMenuNotifications.vue?vue&type=script&lang=js&"
export * from "./SectionMenuNotifications.vue?vue&type=script&lang=js&"
import style0 from "./SectionMenuNotifications.vue?vue&type=style&index=0&id=6f757e79&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f757e79",
  null
  
)

export default component.exports